import { render } from "./TextElementProduction.vue.js?vue&type=template&id=694f9811&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElementProduction.vue?vue&type=template&id=694f9811&scoped=true"
import script from "./TextElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElementProduction.vue?vue&type=script&lang=js"
export * from "./TextElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElementProduction.vue?vue&type=script&lang=js"

import "./TextElementProduction.vue.scss?vue&type=style&index=0&id=694f9811&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElementProduction.vue?vue&type=style&index=0&id=694f9811&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694f9811"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/TextElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "694f9811"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('694f9811', __exports__)) {
    api.reload('694f9811', __exports__)
  }
  
  module.hot.accept("./TextElementProduction.vue.js?vue&type=template&id=694f9811&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TextElementProduction.vue?vue&type=template&id=694f9811&scoped=true", () => {
    api.rerender('694f9811', render)
  })

}


export default __exports__